import RapidPro from '@elem/compPage/RapidPro';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { redirectTo404 } from '@/utils/redirect404';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { pathname, theme, sites } from '@elem/compPage/RapidPro/config/page';
import { ProductProvider, useProductMsg } from '@elem/compPage/RapidPro/ProductProvider';
import { initalState } from '@elem/compPage/RapidPro/context/initalState';

export default function Page({ SEO, pageStatus }: any) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidpro');
    const productMsg = useProductMsg();

    return (
        <PageLayout isNoFixed={true} theme={theme}>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA locale={locale} list={sites} pathname={pathname} />
            <ProductProvider children={<RapidPro />} pageStatus={pageStatus} />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale = 'us', query }: GetServerSidePropsContext) {
    if (!sites.includes(locale)) {
        return redirectTo404();
    }
    const _timer = query?._timer ? String(query?._timer) : undefined;
    const props = initalState(locale, _timer);
    if (props === '404') {
        return redirectTo404();
    }
    return {
        props,
    };
}
